import type { DecimalInput } from '@app/shared';
import { formatQty } from '@/shared/lib/money';

export interface QtyProps {
  value: DecimalInput;
  unit?: string;
  className?: string;
}

export function Qty({ value, unit, className }: QtyProps) {
  return (
    <span className={className ? `tabular-nums ${className}` : 'tabular-nums'}>
      {formatQty(value, unit)}
    </span>
  );
}
